export interface ElasticDocument {
  _index: string;
  _type: string;
  _score: string;
  _id: string;
  _source: any;
}

export interface ArtistDocument extends ElasticDocument {
  _source: {
    id: number;
    name: string;
    dob: number;
    dod: number;
    aliases: string[];
  };
}

export interface ArtworkDocument extends ElasticDocument {
  _source: {
    id: number;
    name: string;
    pictureUrl: string;
    date: number;
    artistId: string;
    d1: number;
    d2: number;
    d3: number;
    edition: string;
    markings: string;
    signed: boolean;
    medium: string;
    saleYear: number;
    editionRank: number;
  };
}

export interface ArtistResult extends ArtistDocument {
  artworks: ArtworkDocument[];
}

export interface SegmentationResult {
  segmentationPrice: number;
  segments: number[];
  data?: ArtworkDocument[];
}

export interface ArtworkData {
  artwork_name: string;
  artwork_date: string;
  date_on_artwork: number;
  signature_on_artwork: number;
  provenance: string;
  exhibited: string;
  literature: string;
  unit: string;
  d1: number | string;
  d2: number | string;
  d3: number | string;
  mediums_analysis: string;
  mediums: number;
  medium_v2_analysis: string;
  medium_v2: number;
  edition_analysis: string;
  markings: string;
  picture_url?: string;
  artistId: number;
  segmentation_price: number | string;
  segmentation_price_v2: number | string;
}

export function getName(result: ArtistDocument) {
  let res = result._source.name;
  const dob = result._source.dob === -1 ? '-' : result._source.dob;
  if (dob) {
    res += ' (' + dob;
    if (result._source.dod) {
      res += '-' + result._source.dod;
    }
    res += ')';
  }
  return res;
}
